import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import type { OffsetPageQueryDTO } from "@/shared/contracts/base";
import { Breadcrumb } from "@/shared/ui/Breadcrumb";
import { useNavigate, useSearch } from "@tanstack/react-router";
import { useCustomersQuery } from "../api/queries";
import { CustomersFilter } from "../ui/CustomersFilter";
import { CustomersTable } from "../ui/CustomersTable";
import { CustomersToolbar } from "../ui/CustomersToolbar";

export function CustomersPage() {
  const nav = useNavigate({ from: "/app/customers" });
  const search: OffsetPageQueryDTO = useSearch({ from: "/app/customers" });
  const list = useCustomersQuery({
    offset: search.offset,
    limit: search.limit,
    sort: search.sort,
    filters: search.filters,
  });

  return (
    <>
      <Header>
        <Breadcrumb
          items={[
            { label: "ແຜງຄວບຄຸມ", to: "/app/dashboard" },
            { label: "ລູກຄ້າ" },
          ]}
        />
      </Header>
      <Main>
        <CustomersToolbar />
        <div className="flex flex-col rounded-xl border bg-card pt-2">
          <CustomersFilter />
          <CustomersTable
            data={list.data?.data ?? []}
            isLoading={list.isLoading}
            offset={search.offset ?? 0}
            limit={search.limit ?? 20}
            totalCount={list.data?.meta?.total ?? 0}
            sortBy={search.sort?.[0]?.field}
            sortOrder={search.sort?.[0]?.dir as "asc" | "desc" | undefined}
            onPaginationChange={(offset, limit) =>
              nav({ search: { ...search, offset, limit } })
            }
            onSortingChange={(id, desc) =>
              nav({
                search: {
                  ...search,
                  sort: [{ field: id, dir: desc ? "desc" : "asc" }],
                },
              })
            }
            onView={(row) =>
              nav({ to: "/app/customers/$id", params: { id: row.id } })
            }
          />
        </div>
      </Main>
    </>
  );
}
